<script lang="ts" setup>
import { useLibraryLtiStore } from '@@/pinia/library_lti_store'
import GlobalAlertDialog from '@@/vuecomponents/GlobalAlertDialog.vue'
import LibraryLtiDeeplinkMenuScreen from '@@/vuecomponents/LibraryLtiDeeplinkMenuScreen.vue'
import LibraryLtiErrorScreen from '@@/vuecomponents/LibraryLtiErrorScreen.vue'
import LibraryLtiLinkDeploymentTokenScreen from '@@/vuecomponents/LibraryLtiLinkDeploymentTokenScreen.vue'
import LibraryLtiSuccessScreen from '@@/vuecomponents/LibraryLtiSuccessScreen.vue'
import { onMounted, watch } from 'vue'
const LibraryLtiDistrictLibrarySelectionScreen = () =>
  import('@@/vuecomponents/LibraryLtiDistrictLibrarySelectionScreen.vue')

const libraryLtiStore = useLibraryLtiStore()

watch(
  () => libraryLtiStore.isAwaitingServerResponse,
  (value) => {
    if (libraryLtiStore.xDeepLinkMenuScreen) return
    const html = document.getElementsByTagName('html')[0]

    // Animate the background color while waiting for the response
    // Note: Only do this when submitting the login form
    if (value) {
      html.classList.add('dot-grid-loading')
    } else {
      html.classList.remove('dot-grid-loading')
    }
  },
)

watch(
  () => libraryLtiStore.xDeepLinkMenuScreen,
  (value) => {
    if (value) {
      const html = document.getElementsByTagName('html')[0]

      // Remove all background classes when entering the deeplink menu screen.
      html.classList.remove('dot-grid')
      html.classList.remove('dot-grid-loading')
    }
  },
)
onMounted(() => {
  if (libraryLtiStore.xDeepLinkMenuScreen) return
  const html = document.getElementsByTagName('html')[0]
  html.classList.add('dot-grid')
})
</script>

<template>
  <div class="w-full h-full">
    <LibraryLtiLinkDeploymentTokenScreen v-if="libraryLtiStore.xLinkDeploymentTokenScreen" />
    <LibraryLtiDeeplinkMenuScreen v-else-if="libraryLtiStore.xDeepLinkMenuScreen" />
    <LibraryLtiErrorScreen v-else-if="libraryLtiStore.xErrorScreen" />
    <LibraryLtiSuccessScreen v-else-if="libraryLtiStore.xSuccessScreen" />
    <LibraryLtiDistrictLibrarySelectionScreen v-else-if="libraryLtiStore.xSelectEnabledDistrictLibraryScreen" />
    <GlobalAlertDialog />
  </div>
</template>

<style lang="postcss">
@import '@@/styles/4/kit';
@import '@@/styles/4/dot_grid';

* {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html {
  @apply h-screen;
  @apply bg-light-ui-100;
  @apply dark:bg-dark-ui-100;
  font-size: 16px;
}
</style>
